

































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  STATUSES as BOOKING_STATUSES,
  TYPES_LABEL,
  BOOKING_PURPOSES,
} from '@/constants/booking';
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from '@/constants/booking_candidate';
import BusinessDashboardBookingDrawer from './BusinessDashboardBookingDrawer.vue';
import { getReportOutcomes, reportOutcome } from '@/utils/questionnaire';

@Component({
  components: {
    BusinessDashboardBookingDrawer,
  },
})
export default class BusinessDashboardBooking extends Vue {
  @Prop({ required: true }) readonly booking!: Model;

  bookingStatuses = BOOKING_STATUSES;
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES;
  bookingTypesLabel = TYPES_LABEL;
  bookingPurposes = BOOKING_PURPOSES;

  showCandidateListDrawer = false;

  outcomes: reportOutcome[] = [];

  beforeMount() {
    this.outcomes = getReportOutcomes(this.booking);
  }

  get chartLabels() {
    return this.booking.purpose ===
      this.bookingPurposes.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
      ? ['Incomplete', 'Complete']
      : [
          'Incomplete',
          'Low risk outcomes',
          'Moderate risk outcomes',
          'High risk outcomes',
        ];
  }

  get chartOptions() {
    return {
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      labels: this.chartLabels,
      colors: [...this.outcomes.map((outcome) => outcome.chart_color)],
      plotOptions: {
        pie: {
          donut: {
            size: '93%',
            labels: {
              show: true,
              name: {
                offsetY: 15,
              },
              value: {
                offsetY: -20,
                fontSize: '20px',
                fontWeight: 'bold',
              },
              total: {
                show: true,
                showAlways: true,
                label: 'Candidates',
                fontSize: '12px',
                fontWeight: 'bold',
                color: '#9a9a9a',
              },
            },
          },
        },
      },
    };
  }

  get series() {
    return this.outcomes.map(
      (outcome) => outcome.booking_candidate_oids.length
    );
  }

  openCandidatesDrawer() {
    this.$store.commit('Booking/SET_STATE', {
      key: 'booking',
      payload: this.booking,
    });
    this.showCandidateListDrawer = true;
  }

  get buttonText() {
    return [
      BOOKING_PURPOSES.PURPOSE_PRE_EMPLOYMENT.key,
      BOOKING_PURPOSES.PURPOSE_RETURN_TO_WORK.key,
    ].includes(this.booking.purpose)
      ? 'View Candidate Reports'
      : 'View Booking Status';
  }
}
